<template>
  <div class="" @click.self="cancel">
    <div>
      <div
        class="cancel-btn"
        :class="{
          totalStyleMobile:
            session[0].type === 'total' && $route.name !== 'SingleGameMarket',
          sportsBookStyle:
            ($route.name !== 'Exchange' &&
              $route.name !== 'SingleGameMarket') ||
            ($route.params.league && $route.params.league.includes('props')),
          exchangeStyle:
            $route.name === 'Exchange' &&
            $route.name !== 'SingleGameMarket' &&
            $route.params.league &&
            !$route.params.league.includes('props'),
          singleGameStyle: $route.name === 'SingleGameMarket',
          spreadStyle:
            session[0].type === 'spread' &&
            $route.name !== 'Exchange' &&
            $route.name !== 'SingleGameMarket',
        }"
        @click.stop="cancel"
      >
        <div
          class="inner-div"
          :class="{ 'inner-div-single': $route.name === 'SingleGameMarket' }"
        >
          ×
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores/user';
import { emitter } from '@/core/emitter';
const userStore = useUserStore();

const props = defineProps({
  session: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['cancelBet']);

function findOwnSession(props, userId) {
  if (!props || typeof props !== 'object' || !props.session) {
    return null;
  }

  let orderedSessions = props.session;
  if (Array.isArray(orderedSessions[0])) {
    orderedSessions = orderedSessions[0];
  }

  function checkSession(item) {
    if (Array.isArray(item)) {
      return item.find((subItem) => checkSession(subItem));
    }
    return item.createdBy === userId;
  }
  return orderedSessions.find(checkSession);
}

function cancel() {
  const ownSession = findOwnSession(props, userStore.user.id);
  // An aggregate book row can hold several of the user's orders; cancelling
  // by the row's single stamped id would silently pick one, so send the user
  // to the open-offers list to choose which order to cancel.
  if (ownSession?.multipleUserOrders) {
    emitter.emit('openOffersForGame', ownSession.gameID);
    return;
  }
  emit('cancelBet', ownSession);
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/tokens.scss' as main;

.cancel-btn {
  position: absolute;
  right: 1px;
  padding: 0;
  width: 8px;
  cursor: pointer;
  color: main.$white_02;
  font-size: 9px;
  z-index: 1;
  background-color: main.$green-202;
  height: 10px;

  &:hover {
    background-color: main.$green-301;
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    margin-top: 1px;
  }
}

.inner-div {
  margin-top: -2px;
}

.inner-div-single {
  margin-left: 4px;
}

.totalStyleMobile {
  right: 1px;
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    right: 9px !important;
  }
}

.sportsBookStyle {
  width: 13px;
  margin-top: 0px;
  right: 8px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  height: 13px;
  font-size: 11px;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    margin-top: 1px;
    right: 1px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}

.singleGameStyle {
  width: 13px;
  margin-top: 0px;
  right: 0;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  height: 13px;
  font-size: 11px;
}

.spreadStyle {
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    width: 13px;
    margin-top: 0px;
    right: 5px;
    height: 13px;
    font-size: 11px;
  }
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    width: 13px;
    margin-top: 1px;
    right: 1px;
    height: 13px;
    font-size: 11px;
  }
}

.exchangeStyle {
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    width: 13px;
    margin-top: 0px;
    height: 13px;
    font-size: 11px;
    margin-top: 1px;
  }
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    width: 13px;
    height: 13px;
    margin-top: 1px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0px;
    font-size: 11px;
  }
}
</style>
